export const RECEIVE_INITIAL_CAMPAIGN = 'RECEIVE_INITIAL_CAMPAIGN';
export const RECEIVE_COURSE_CLONE = 'RECEIVE_COURSE_CLONE';
export const RECEIVE_COURSE = 'RECEIVE_COURSE';
export const RECEIVE_COURSE_UPDATE = 'RECEIVE_COURSE_UPDATE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const CREATED_COURSE = 'CREATED_COURSE';
export const PERSISTED_COURSE = 'PERSISTED_COURSE';
export const DISMISS_SURVEY_NOTIFICATION = 'DISMISS_SURVEY_NOTIFICATION';
export const TOGGLE_EDITING_SYLLABUS = 'TOGGLE_EDITING_SYLLABUS';
export const START_SYLLABUS_UPLOAD = 'START_SYLLABUS_UPLOAD';
export const SYLLABUS_UPLOAD_SUCCESS = 'SYLLABUS_UPLOAD_SUCCESS';
export const LINKED_TO_SALESFORCE = 'LINKED_TO_SALESFORCE';
